module.exports = __webpack_public_path__ + "img/drill2_7-7-2021.546aed90.jpg";